var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mm-time-picker-panel-select"},[_c('ul',{staticClass:"mm-time-picker-list",on:{"click":_vm.handleSelect}},_vm._l((_vm.list),function(item){return _c('li',{key:item.value,staticClass:"mm-time-picker-item",class:{
        'mm-time-picker-item--disabled': item.disabled,
        'mm-time-picker-item--active': item.value === _vm.value
      }},[_vm._v("\n      "+_vm._s(`0${item.value}`.slice(-2))+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }